import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { router } from "@/router";
import "@/styles/globals.css";

// Все страницы — lazy-чанки, а `vite build` на проде опустошает `dist`: вкладка,
// открытая до деплоя, при переходе на ещё не загруженный маршрут получает 404
// старого чанка. Перезагрузка подтягивает свежий index.html с новыми хэшами.
// Страховка от петли: не чаще раза в минуту (если и новый index.html не
// помогает, пусть человек увидит ошибку, а не бесконечное мигание).
window.addEventListener("vite:preloadError", (event) => {
  const key = "signaris_preload_reload_at";
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(key) ?? 0);
  } catch {
    // sessionStorage недоступен (приватный режим) — перезагружаем без защиты.
  }
  if (Date.now() - last < 60_000) return;
  try {
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    // см. выше
  }
  event.preventDefault();
  window.location.reload();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Включено: при возвращении на вкладку обновляем — это естественный
      // момент, когда пользователь хочет видеть свежие данные (особенно
      // /me с product_roles после того как админ их поменял).
      refetchOnWindowFocus: true,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          className: "font-sans",
          style: {
            background: "rgba(15, 18, 32, 0.95)",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "#F0F0F5",
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>,
);
